export const PATH_LIST_FOR_ENTRANCE_PAGE_SCENE = [
  '/collections/',
  '/campaigns/',
  '/anniversary-deals',
  '/black-friday-deals',
  '/bfcm_activity',
  '/special-offers',
  '/clearance',
  '/vooglam-tombogo-collection',
  '/blue-light-glasses',
  '/transitions-lenses',
  '/progressive-lenses',
  '/photochromic-lenses',
];

// 需要阻止爬虫的接口路径模式
export const BLOCKED_API_PATTERNS = ['/api/customer/get_time_sign'];
